import axios from "@/common/interceptors.service";
import ApiService from "@/common/api.service";

export default {
  fetchTags() {
    return axios.get("http://localhost:3000/tags");
  }
};
